export {
    auth,
    logout,
    setAuthRedirectPath,
    authCheckState
    // modalClicked
} from './auth';


// WEBPACK FOOTER //
// ./src/store/actions/index.js